import { defineNuxtPlugin } from '#app';
import VueQrcode from 'vue-qrcode'

export default defineNuxtPlugin((nuxtApp) => {
       nuxtApp.vueApp.use(VueQrcode);
});